export var EnrollPatientCaseInitiator;
(function (EnrollPatientCaseInitiator) {
    EnrollPatientCaseInitiator["patient"] = "patient";
    EnrollPatientCaseInitiator["pharmacy"] = "pharmacy";
    EnrollPatientCaseInitiator["provider"] = "provider";
})(EnrollPatientCaseInitiator || (EnrollPatientCaseInitiator = {}));
//# sourceMappingURL=EnrollPatientCaseInitiator.js.map